module.exports = __webpack_public_path__ + "static/media/Talia Austin VPMA_1585002071501.98a39d65.png";